<template id="Login">
    <div class="content">
      <div class="contentDiv">
        <ul>
        <li>登入</li><br>
        <li>帳號: <input type="text" v-model="account"></li><br>
        <li>密碼: <input type="password" v-model="password"></li><br>
        <li><button class="loginbtn" @click="Authenication()">送出</button></li>
        </ul>
      </div>
    </div>
</template>
<script>
import firebase from 'firebase';
export default {
  data: function() {
    return {
     account:'',
     password:''
    };
  },
  methods:{
    Authenication(){
        let firebaseAuth = firebase.auth();
        let account = this.account;
        let password = this.password;
        firebaseAuth.signInWithEmailAndPassword(account, password)
        .then(() => {
          this.$router.replace({ name: "HelloGuest" });
        }).catch(err => {
          alert(err);
        }).then(()=>{
          var user = firebaseAuth.currentUser;
          if (user) {
            alert("User has already signed in.")
          } else {
            alert("Cannot find any user.")
          }
        });
    }
  }
}
</script>
<style scoped>
@media only screen and (min-width: 769px) {
  .content{
    height: 200px;
    width: 400px;
    position: absolute;    
    top: 50%;              
    left: 50%;             
    margin-top: -100px;     
    margin-left: -200px;    
    font-size:20px;
    border-width:medium; border-style:dashed;
  }
  .contentDiv{
    margin-top:30px;
    text-align: center;
  }
}

@media only screen and (min-width: 0px) and (max-width: 320px) {
  .content{
    height: 200px;
    width: 300px;
    position: absolute;    
    top: 50%;              
    left: 65%;             
    margin-top: -100px;     
    margin-left: -200px;    
    font-size:18px;
    border-width:medium; 
    border-style:dotted;
  }
  .contentDiv{
    margin-top:30px;
    text-align: center;
  }
}
</style>